import React, { useState } from "react";
import axios from "axios";

const useFileType = ({
    onFinish = ({ axiosMode, status, values }) => {},
    onBefore = ({ axiosMode, status }) => {},
}) => {
    const [data, setData] = useState([]);
    let mainApi = `/media_classification_storage/api/file_type`;
    const getFileTypeData = (params) => {
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get(mainApi, {
                params: params,
            })
            .then((response) => {
                let data = response.data;
                setData(data?.data);
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error",
                    });
                }
                getFileUrl(data?.data)
                return {
                    ...data,
                };
            });
    };
    const postFileTypeData = (data) => {
        onBefore({
            axiosMode: "post",
        });
        axios
            .post(mainApi, data)
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "fail") {
                    onFinish({
                        axiosMode: "post",
                        status: "error",
                    });
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "success",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "error",
                });
            });
    };
    const patchFileTypeData = (data) => {
        onBefore({
            axiosMode: "patch",
        });
        axios
            .patch(
                mainApi,

                data
            )
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "fail") {
                    onFinish({
                        axiosMode: "patch",
                        status: "error",
                    });
                } else {
                    onFinish({
                        axiosMode: "patch",
                        status: "success",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "patch",
                    status: "error",
                });
            });
    };
    const deleteFileTypeData = (data) => {
        onBefore({
            axiosMode: "delete",
        });
        axios
            .delete(mainApi, {
                data,
            })
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "fail") {
                    onFinish({
                        axiosMode: "delete",
                        status: "error",
                    });
                } else {
                    onFinish({
                        axiosMode: "delete",
                        status: "success",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "delete",
                    status: "error",
                });
            });
    };
    const getFileUrl =(data)=>{
        data.forEach(element => {
            if (element?.file_id) {
                axios
                    .get('/media_classification_storage/api/file/upload', {
                        responseType: 'blob',
                        params: {
                            "file_id": element?.file_id
                        }
                    })
                    .then((response) => {
                        var blob_ = new Blob([response.data], {
                            type: "image/jpg",// this is the only MIME for SVG

                        });
                        const dataurl = URL.createObjectURL(blob_);
                        setData(
                            (pre) => {
                                return (
                                    pre.map((value, index) => {
                                        if (element?.file_id === value?.file_id) {
                                                return (
                                                    {
                                                        ...value,
                                                        file_url: dataurl
                                                    }
                                                )
                                        } else {
                                            return (
                                                {
                                                    ...value,
                                                }
                                            )
                                        }
                                    })
                                )
                            }
                        )
                    })
            }


        })
    }
    const getDocumentFileTypeImage = (file_client_name, fileTypeData) => {
        if(fileTypeData){
            for (let type of fileTypeData) {
                const regex = new RegExp(`\\.(${type.file_extension})$`, 'i');  // 動態生成正則
                if (regex.test(file_client_name)) {
                    return {
                        ...type
                    }
                }
            }
            return {
                "file_type_id": null,
                "name": "未知文件",
            }
        }
        else{
            for (let type of data) {
                const regex = new RegExp(`\\.(${type.file_extension})$`, 'i');  // 動態生成正則
                if (regex.test(file_client_name)) {
                    return {
                        ...type
                    }
                }
            }
            return {
                "file_type_id": null,
                "name": "未知文件",
            }
        }
      
    }
    return {
        FileTypeData: data,
        getFileTypeData,
        postFileTypeData,
        patchFileTypeData,
        deleteFileTypeData,
        getDocumentFileTypeImage
    };
};
export { useFileType };
